import { toast } from 'sonner';
import i18n from 'i18next';

import { getIntegrationErrorMessage } from '@/lib/integration-error-message.js';
import { useTenantMfaSettingsStore } from '@/store/tenant-mfa-settings.store.js';

export class TenantMfaSettingsIntegration {
    constructor(sdkService) {
        this.service = sdkService;
    }

    async fetch() {
        const store = useTenantMfaSettingsStore.getState();
        store.setLoading(true);
        store.setError(null);
        try {
            const response = await this.service.get();
            store.setSettings(response.data || null);
            return { success: true, data: response.data };
        } catch (error) {
            const message = getIntegrationErrorMessage(error)
                || i18n.t('platformMfa:messages.loadFailed', {
                    defaultValue: 'Could not load MFA settings',
                });
            store.setError(message);
            toast.error(message);
            return { success: false, error: message };
        } finally {
            store.setLoading(false);
        }
    }

    async update(payload) {
        const store = useTenantMfaSettingsStore.getState();
        store.setLoading(true);
        try {
            const response = await this.service.update(payload);
            store.setSettings(response.data || null);
            toast.success(
                i18n.t('platformMfa:messages.updateSuccess', {
                    defaultValue: 'MFA settings saved',
                }),
            );
            return { success: true, data: response.data };
        } catch (error) {
            const message = getIntegrationErrorMessage(error)
                || i18n.t('platformMfa:messages.updateFailed', {
                    defaultValue: 'Could not save MFA settings',
                });
            toast.error(message);
            return { success: false, error: message };
        } finally {
            store.setLoading(false);
        }
    }
}
